import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import useChatHistory from '../../ChatPage/hooks/useChatHistory';
import { ResizableContainer } from '../../components/ResizableContainer';
import { ChatShareConversationPage } from './ChatShareConversationPage';
import { ChatDSTemplateActionsShareList } from './ChatDSTemplateActionsShareList';
import ChatSmartTableShare from './ChatSmartTableShare';
import ChatMagicPosterShare from './ChatMagicPosterShare';
import ChatAiGalleryShare from './ChatAiGalleryShare';
import { ChatContentType } from '../../ChatDSTemplate/type';
import { getCosReportPanelKey } from '../../ChatDSTemplate/utils';
import { useSize } from 'ahooks';

/** 分享场景下的右侧面板组件映射 */
const SHARE_PANEL_MAP = {
  [ChatContentType.Document]: ChatDSTemplateActionsShareList,
  [ChatContentType.SmartTable]: ChatSmartTableShare,
  [ChatContentType.MagicPoster]: ChatMagicPosterShare,
  [ChatContentType.AiGallery]: ChatAiGalleryShare,
};

// 分享含ds报告数据
export const ChatShareConversationPageWithDsReport = ({ data, snapshotId, poolId, sessionId, contentType = ChatContentType.Document }: any) => {
  const { dsReport, handleUpdateDsReport, conversations } = useChatHistory();
  const isExpanded = dsReport?.show;
  const [isSHowMenu, setIsSHowMenu] = useState(false);
  const initialWidth = useSize(document.querySelector('.dba-chat-page'));
  const LayoutContainer = (
    isExpanded ? 'div' : React.Fragment
  ) as React.ElementType;

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const menuExists = !!document.querySelector('.dba-menu-small');
      setIsSHowMenu(menuExists);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  // 点卡片后以 dsReport.componentType 为准：同会话既有表格又有 HTML 时，
  // 页面级 contentType 会因 ai_excel / hasCosExcel 锁死 SmartTable，HTML 卡片点开仍走表格。
  const panelContentType = ((dsReport as { componentType?: ChatContentType; })
    ?.componentType || contentType) as ChatContentType;
  // 根据面板类型动态选择组件
  const PanelComponent = useMemo(() => {
    return SHARE_PANEL_MAP[panelContentType] || SHARE_PANEL_MAP[ChatContentType.Document];
  }, [panelContentType]);

  // 正文 <cos> 卡片切换时重新挂载面板，确保点击哪张就请求哪张的数据
  const panelKey = useMemo(() => getCosReportPanelKey(dsReport), [dsReport]);
  const containerProps = isExpanded
    ? {
      className: classNames({
        'dba-chat-ds-report-page': isExpanded,
        'dba-chat-ds-container': isExpanded,
        'dba-chat-ds-report-share-page': true,
        // FIXME:: 以下2个样式需要删除，暂时搞不定...
        'dba-chat-ds-isShowMenu': isSHowMenu,
        // 'dba-chat-ds-isMinWidth': initialWidth?.width < 700
      }),
      style: {
        '--sticky-width': initialWidth?.width ? `${initialWidth.width}px` : '100%'
      },
    }
    : {};
  return <LayoutContainer {...containerProps}>
    <ResizableContainer
      minWidth={442}
      maxWidth={700}
      initialWidth={442}
      isShowMask={false}
      isShowResize={isExpanded as boolean}
    >
      {/* 左侧QA问答页 */}
      <ChatShareConversationPage  {...{ data, snapshotId, poolId, isDs: contentType === ChatContentType.Document, sessionId }} />
    </ResizableContainer>
    {isExpanded && (
      <PanelComponent
        key={panelKey}
        {...{
          handleUpdateDsReport,
          conversations,
          dsReport,
          sessionId,
          data
        }}
      />
    )}
  </LayoutContainer>;
};
